import { getTemperature } from '../../../../helper/temperature';

export function P00043ConsigneTemperatureEnum() {
  let r = [];

  for (let i = 20; i <= 30; i++) {
    r.push({
      ref: i,
      label: getTemperature(i, 0),
      visible: true,
    });
  }

  return r;
}
